<script setup lang="ts">
import { ReviewItem } from "@/components/Reviews";
import { Ticker } from "@/components/Ui";
import { computed } from "vue";
import { useTextDirection } from "@vueuse/core";

const dir = useTextDirection();

interface Props {
  items?: any;
}

const props = defineProps<Props>();
const middleIndex = Math.ceil(props.items?.length / 2);
const topItems = computed(() => {
  let arr = props.items ? [...props.items] : [];
  return arr.splice(0, middleIndex);
});
const bottomItems = computed(() => {
  let arr = props.items ? [...props.items] : [];
  return arr.splice(middleIndex);
});
</script>

<template>
  <div :class="$style.root">
    <Ticker :duration="Number(`${topItems.length}00`) / 2" :direction="dir === 'ltr' ? 'normal' : 'reverse'">
      <div :class="$style['root-top']">
        <ReviewItem
          v-for="(item, index) in topItems"
          :key="index"
          :item-id="item.id"
          is-favorite-block
          :class="$style['root-item']"
        />
      </div>
    </Ticker>
    <Ticker
      :duration="Number(`${bottomItems.length}00`) / 2"
      :direction="dir === 'ltr' ? 'reverse' : 'normal'"
    >
      <div :class="$style['root-bottom']">
        <ReviewItem
          v-for="(item, index) in bottomItems"
          :key="index"
          :item-id="item.id"
          is-favorite-block
          :class="$style['root-item']"
        />
      </div>
    </Ticker>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply w-full flex flex-col gap-5;

  &-top {
    @apply flex gap-5 mr-5;
  }

  &-bottom {
    @apply flex gap-5 ml-5;
  }

  &-item {
    @apply max-w-[320px] min-w-[320px];

    @screen md {
      @apply max-w-[540px] min-w-[540px];
    }
  }
}
</style>
